import { createFileRoute, redirect } from "@tanstack/react-router";

// /seo-services has been consolidated into /local-seo, the canonical Colorado
// SEO hub. The two pages were near-duplicates targeting the same buyer and
// hubbing to the same city pages — classic keyword cannibalization. This 301
// preserves any inbound link equity from old WordPress URLs, ad campaigns,
// and external citations while pointing all SEO traffic at one strong page.
export const Route = createFileRoute("/seo-services")({
  beforeLoad: () => {
    throw redirect({ to: "/local-seo", statusCode: 301 });
  },
  component: () => null,
});
